import type { TabSettingsData } from './../Atom.model';
import type { AtomGroup, TypeSettings } from '@/app/editor/iframe/atom/Atom.model';
import type { CheckAtomGroupFunction } from '@/app/utils/AtomGroupHelper';
import { addModuleGroupJquery, CheckAtomGroupMap } from '@/app/utils/AtomGroupHelper';
import HELPER from '@/app/utils/HELPER';
import { AutoRenderSetting } from '@/app/editor/sidebar/settings/AutoRenderSetting';
import type { Observer, Subject } from '@/app/editor/iframe/atom/service/observer';
import { DataManager } from '@/app/editor/iframe/atom/service/DataManager';

import atom from '@/app/editor/iframe/atom';

/**
 * Xử lý thao tác drag$drop khi Atom đang ở LivePage
 * @param tab tab name
 * @param drag drag or click
 */
export class Dragable implements Observer {
  public $el: JQuery;
  public data = {} as TypeSettings;
  $gfFrame = jQuery('#gfFrame');
  /** constructor
   * @param element DOM
   * @param options Seting
   */
  constructor(element: HTMLElement, options?: TypeSettings) {
    // init everthing

    this.$el = jQuery(element); // merge element to $el
    this.applyDrag();
    DataManager.registerObserver(this);
  }

  /**
   * update data change
   * @param subject obs
   */
  update(subject: Subject): void {
    //
  }
  /**
   * applyDrag
   */
  applyDrag(): void {
    const currentId = this.$el.attr('data-id') || '';
    const atomData = DataManager.getAtomDataById(currentId);
    const type = atomData.type;
    let $aHandle: any;
    switch (type) {
      case 'row': {
        $aHandle = this.$el.children('.gf-tool-wrap').find('.r-handle');
        break;
      }
      case 'module': {
        $aHandle = this.$el.children('.gf-tool-wrap').find('.m-handle');
        break;
      }
      case 'element': {
        $aHandle = this.$el.children('.gf-tool-wrap').find('.e-handle');
        break;
      }
    }
    // OPTIMIZE FOR TAB ONLY Tabs
    // REFRESH CHILD MODULES WHEN TAB IS CLICKED
    const _this = this;
    this.$el
      .find('.gf_tab span')
      .off('mousedown')
      .on('mousedown', function () {
        const $li = jQuery(this).closest('li');
        const index = $li.attr('data-index');

        const moduleId = atomData.id;
        const moduleIdSlug = moduleId.toString().replace(/-/g, '');

        const func = 'getTab' + moduleIdSlug;
        if ((document as any).getElementById('gfFrame').contentWindow[func]) {
          (document as any).getElementById('gfFrame').contentWindow[func]().showAllDetaches();
        }

        HELPER.generatePlaceholderForm(_this.$el);
        setTimeout(function () {
          _this.$el
            .children('.module')
            .find('.gf_tab-panel[data-index="' + index + '"]')
            .each(function () {
              jQuery(this)
                .children('.gf_row, .module-wrap, .element-wrap')
                .each(function () {
                  const $mer = jQuery(this);
                  if ($mer.hasClass('gf_row')) {
                    if ($mer.data('gfrow') != undefined) {
                      $mer.data('gfrow').refresh();
                    } else {
                      // $mer.gfRow();
                      atom.Init($mer);
                    }
                  } else if ($mer.hasClass('module-wrap')) {
                    if ($mer.data('gfmodule') != undefined) {
                      $mer.data('gfmodule').refresh();
                    } else {
                      // $mer.gfModule();
                      atom.Init($mer);
                    }
                  } else if ($mer.hasClass('element-wrap')) {
                    if ($mer.data('gfelement') != undefined) {
                      $mer.data('gfelement').refresh();
                    } else {
                      // $mer.gfElement();
                      atom.Init($mer);
                    }
                  }
                });
            });
        }, 300);
      });

    if (this.$el.attr('data-label') == 'Popup') {
      // ???
    } else {
      const _this = this;
      const type = atomData.type;
      $aHandle.gfDraggable({
        targetElement: this.$el,
        type: type,
        /**
         * start drag
         * @returns true/false
         */
        start: function () {
          $aHandle.closest('.gf-tool').removeClass('gf-expand');

          // this.emit('openSetting')
          return false;
        },
        /**
         * stop drag
         * @returns true/false
         * @param nearY vertical
         * @param $from from Atom?
         * @param $to to Atom?
         * @param $stElement ???
         * @param $dragHidden ???
         */
        stop: function (
          nearY: any,
          $from: JQuery,
          $to: JQuery,
          $stElement: JQuery,
          $dragHidden: JQuery,
          notDragging?: boolean,
        ) {
          _this.openAtomSettings('Settings', false);
          if (notDragging) {
            return;
          }

          if (!$stElement) {
            return;
          }

          if (nearY != undefined) {
            let index = nearY.id;
            if (index < 0) {
              index = 0;
            }
            const $newPlace = window.$gfPlaceHolders.eq(index);
            if ($newPlace.length === 1) {
              $to = $newPlace.closest('.item-content');

              let flag = true;
              let atomGroup = _this.$el.attr('data-atomgroup') as AtomGroup | undefined;
              if (!atomGroup) {
                atomGroup = addModuleGroupJquery(_this.$el);
              }
              const checkGroupFunction = CheckAtomGroupMap[atomGroup] as CheckAtomGroupFunction;

              const moduleName = atomData.name;
              /*
                CÁC TRƯỜNG HỢP KHÔNG ĐƯỢC DI CHUYỂN

                1, Module (P) không được kéo ra ngoài Product
                2, Module (A) không được kéo ra ngoài Article
                3, Product không được kéo vào Product, Product List, Related Products, Article List
                4, Article không được kéo vào Article, Product List, Related Products, Article List

                5, Product List, Related Products, Article List không được kéo vào Product, Article, Product List, Related Products, Article List

                6, Element chứa (P) không được kéo ra ngoài Product
                7, Element chứa (A) không được kéo ra ngoài Article

                */

              // cannot drag to list after drag from leftsidebar
              if (
                HELPER.isInsideTheList($to) &&
                (moduleName == 'WideBundle' || moduleName == 'Product Filter Search')
              ) {
                flag = false;
                HELPER.showNotify('Cannot put a ' + moduleName + ' inside a Product List.', 'error', 5000);
              }
              if (HELPER.isInsideTheList($to) && moduleName == 'PickyStory') {
                flag = false;
                HELPER.showNotify('Cannot put a ' + moduleName + ' inside a Product List.', 'error', 5000);
              }
              if (
                moduleName == 'Ultimate Sales Boost' &&
                HELPER.isInsideTheList($to) &&
                $to.closest('[data-label="Product List"]').length > 0
              ) {
                if (this.$gfFrame.data('gfframe').getPageType() == 'template-product') {
                  flag = false;
                  HELPER.showNotify(
                    'Cannot put a ' + moduleName + ' into a Product List of Product Page',
                    'error',
                    5000,
                  );
                }
              }

              if (
                typeof checkGroupFunction == 'function' &&
                !checkGroupFunction($to, {
                  $from,
                  moduleName,
                  $stElement,
                  pageType: _this.$gfFrame.data('gfframe').getPageType(),
                })
              ) {
                flag = false;
              }

              // related products
              if (
                $stElement.attr('data-label') == 'Related Products' ||
                $stElement.find('[data-label="Related Products"]').length > 0
              ) {
                if ($to.closest('[data-label="Product"]').length > 0) {
                  flag = false;
                  HELPER.showNotify('Related Products cannot be dropped inside Product.', 'error');
                }
              }
              if (flag) {
                if (
                  typeof checkGroupFunction == 'function' &&
                  !checkGroupFunction($to, {
                    $from,
                    moduleName,
                    $stElement,
                    pageType: _this.$gfFrame.data('gfframe').getPageType(),
                  })
                ) {
                  flag = false;
                }
              }
              if (flag) {
                $aHandle.data('gfdraggable').manageStop($newPlace, $stElement, $from, $to);
                // RefreshDrag Parallax in Row full width
                if ($stElement && $stElement.attr('data-label') == 'Parallax') {
                  const moduleId = atomData.id;
                  // let moduleIdSlug = moduleId.toString().replace(/-/g, '');
                  const func = 'getParallax' + moduleId;
                  if ((document as any).getElementById('gfFrame').contentWindow[func]) {
                    (document as any).getElementById('gfFrame').contentWindow[func]().refreshDrag();
                  }
                }
              } else {
                if ($dragHidden) {
                  $dragHidden.after($stElement);
                  window._isDetached = false;
                }
              }
            } else {
              if ($dragHidden) {
                $dragHidden.after($stElement);
                window._isDetached = false;
              }
            }
          } else {
            if ($dragHidden) {
              $dragHidden.after($stElement);
              window._isDetached = false;
            }
          }
          if ($dragHidden) {
            $dragHidden.remove();
          }

          const currentAtomId: string = _this.$el.attr('data-id') || '';
          if (_this.$el.attr('data-compile') == 'false') {
            const type = atomData.type;
            // const atomId = atomData.id;
            const style = atomData.style;
            switch (type) {
              case 'element': {
                // STORE.setValue(`__setStyle-${atomId}`, style);
                DataManager.setState('changeSetting', { type: 'css', data: style }, currentAtomId);
                break;
              }
              case 'module': {
                if (atomData.style !== style) {
                  // STORE.setValue(`__setStyle-${atomData.id}`, style);
                }
                DataManager.setState('changeSetting', { type: 'all' }, currentAtomId);
                // STORE.setValue(`__refresh-${atomId}`, true);
                // DataManager.setState("changeSetting", {type: "css", data: style});
                DataManager.getInstance().notify();
                break;
              }
            }
          }
          if (atomData.isAutorenderSetting) {
            try {
              // const settingData = STORE.getValue("__openSettingAtom");
              const dataSetting: TabSettingsData = DataManager.getDataSetting(currentAtomId);
              const ar = new AutoRenderSetting(dataSetting.$atom, dataSetting.atom);
              const settingUpdate: any = ar.changeSetting();
              DataManager.setState(
                'setting',
                {
                  changed: true,
                  data: settingUpdate,
                  tab: 'Settings',
                  drag: false,
                  capture: undefined,
                  forceOpen: true,
                },
                currentAtomId,
              );
              // STORE.events.trigger(`setSetting-${settingData.atom.id}`, settingUpdate);
              // Change value data setting and Require Update to Atom
              DataManager.getInstance().notify();
              // Open Setting action
              DataManager.setState('openSetting', true, currentAtomId);
              DataManager.getInstance().notify();
            } catch (err) {
              // eslint-disable-next-line no-console
              console.log(err.message);
            }
          }
        },
      });
    }

    return;
  }

  /**
   * openAtomSettings
   * @param tab  ..
   * @param drag ..
   */
  openAtomSettings = (tab: string | undefined, drag = false): void => {
    const currentAtomId: string = this.$el.attr('data-id') || '';
    DataManager.setTabSettingsDataField(
      {
        tab: tab,
        drag: drag,
        capture: true,
        forceOpen: false,
      },
      currentAtomId,
    );
    DataManager.setState('openSetting', true, currentAtomId);
    DataManager.getInstance().notify();
  };
}
